import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie, X } from "lucide-react";
import { useLang } from "../i18n/LanguageProvider";

// Non-sensitive UI preference: user-chosen cookie category. Not a credential.
const KEY = "bw_cookie_consent";

export const CookieBanner = () => {
  const { t } = useLang();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const decided = localStorage.getItem(KEY);
    if (!decided) {
      const t2 = setTimeout(() => setVisible(true), 3200);
      return () => clearTimeout(t2);
    }
    // setVisible from useState is stable; module-level KEY is a constant.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const decide = (choice) => {
    localStorage.setItem(KEY, choice);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-6 left-6 right-6 md:left-auto md:right-6 md:max-w-md z-[60] glass p-6 border border-[var(--bw-gold)]/40"
      role="dialog"
      aria-label="Cookie preferences"
    >
      <div className="flex items-start gap-4">
        <Cookie size={22} className="text-gold shrink-0 mt-1" strokeWidth={1.4} />
        <div className="flex-1">
          <div className="text-gold text-[10px] tracking-[0.32em] uppercase mb-2">{t("cookie.eyebrow")}</div>
          <p className="text-white/85 text-sm leading-relaxed">
            {t("cookie.text")}{" "}
            <Link to="/cookies" className="text-gold hover:underline">{t("cookie.link")}</Link>.
          </p>
          <div className="mt-5 flex items-center gap-3">
            <button
              onClick={() => decide("accepted")}
              className="btn-gold"
              data-testid="cookie-accept"
              style={{ padding: "0.6rem 1.2rem", fontSize: "0.72rem" }}
            >
              {t("cookie.accept")}
            </button>
            <button
              onClick={() => decide("essential")}
              className="btn-ghost"
              data-testid="cookie-essential"
              style={{ fontSize: "0.72rem" }}
            >
              {t("cookie.essential")}
            </button>
          </div>
        </div>
        <button
          onClick={() => decide("dismissed")}
          className="text-white/60 hover:text-white"
          aria-label="Dismiss"
          data-testid="cookie-close"
        >
          <X size={16} />
        </button>
      </div>
    </div>
  );
};

export default CookieBanner;
